import { getSelectedAssociatedCustomer } from "../../components/common/helper/helper";
import {
  apiHeaderWithSiteId,
  getWishListAPIUrl,
  updateCartAPIUrl,
  clearWishListAPIUrl
} from "./../../utils/urls";
import { loadingEnd, loadingStart } from "./root.actions";

export const getWishListData = (token, payload) => async (dispatch) =>{
    dispatch(loadingStart());
    let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
        headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }
    return await fetch(getWishListAPIUrl, {
      headers: headers,
      method: "POST",
      body: JSON.stringify(payload),
    })
    .then((response) => response.json())
    .then((res) => {
    dispatch(loadingEnd());
        return res;
    })
    .catch((err) => {
        return err;
    });
  };


export const moveCartToCartItemsDataAction = (token, updateCartPayload) => async (dispatch) => {
  dispatch(loadingStart());
  let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }

    return await fetch(updateCartAPIUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(updateCartPayload),
    })
    .then((response) => response.json())
    .then((res) => {
      dispatch(loadingEnd());
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export const clearWishListDataAction = (token) => async (dispatch) => {
  dispatch(loadingStart());
  let headers = apiHeaderWithSiteId;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    if (getSelectedAssociatedCustomer() !== null) {
      headers.AssociatedCustomer = getSelectedAssociatedCustomer();
    }
    return await fetch(clearWishListAPIUrl, {
      method: "GET",
      headers: headers,
    })
    .then((response) => response.json())
    .then((data) => {
      dispatch(loadingEnd());
      return data;
    })
    .catch((err) => {
      return err;
    });
}